import Alpine from "alpinejs";
import { Swiper } from "swiper";
import { Navigation, Autoplay, Pagination } from "swiper/modules";

// PLUGINS
import collapse from "@alpinejs/collapse";
import focus from "@alpinejs/focus";
import intersect from "@alpinejs/intersect";
import morph from "@alpinejs/morph";
import ui from "@alpinejs/ui";
import dialog from "./plugins/dialog";

Alpine.plugin(collapse);
Alpine.plugin(focus);
Alpine.plugin(intersect);
Alpine.plugin(morph);
Alpine.plugin(ui);
Alpine.plugin(dialog);

import history from "./plugins/history";
import share from "./plugins/share";

Alpine.plugin(history);
Alpine.plugin(share);

// STORES
import cart from "./stores/cart";
Alpine.store("cart", cart);

// COMPONENTS
import media from "./components/media";
Alpine.data("media", media);

import product from "./components/product";
Alpine.data("product", product);

import productRecommendations from "./components/productRecommendations";
Alpine.data("productRecommendations", productRecommendations);

import numberInput from "./components/numberInput";
Alpine.data("numberInput", numberInput);

import validation from "./components/validation";
Alpine.data("validation", validation);

// Gallery Scroller
Alpine.data("galleryScroller", () => ({
	swiperInstance: null,
	initSwiper() {
		const container = this.$el;
		const section = container.closest('section');
		const autoplay = section ? JSON.parse(section.querySelector('[data-autoplay]')?.getAttribute('data-autoplay') || 5000) : 5000;
		const loop = section ? JSON.parse(section.querySelector('[data-loop]')?.getAttribute('data-loop') || true) : true;
		this.swiperInstance = new Swiper(container, {
			modules: [Navigation, Autoplay],
			slidesPerView: 2.2,
			spaceBetween: 0,
			loop: loop,
			speed: 5000,
			autoplay: loop ? {
				delay: autoplay,
				disableOnInteraction: false,
			} : false,
			breakpoints: {
				769: {
					slidesPerView: 4,
				}
			}
		});
	},
	destroy() {
		if (this.swiperInstance) {
			this.swiperInstance.destroy(true, true);
			this.swiperInstance = null;
		}
	}
}));

window.Alpine = Alpine;


	// Initialize brand links slider
let brandsSliderInstance = null;
function initBrandsSlider() {
	const brandsSlider = document.querySelector(".collection-links-slider");
	if (brandsSlider) {
		// Destroy existing instance if it exists
		if (brandsSliderInstance) {
			brandsSliderInstance.destroy(true, true);
		}

		brandsSliderInstance = new Swiper(brandsSlider, {
			modules: [Navigation],
			slidesPerView: 2,
			slidesPerGroup: 2,
			spaceBetween: 10,
			autoplay: false,
			navigation: {
				nextEl: ".swiper-brands-button-next",
				prevEl: ".swiper-brands-button-prev",
			},
			breakpoints: {
				320: {
					slidesPerView: 3,
					slidesPerGroup: 3
				},
				640: {
					slidesPerView: 5,
					slidesPerGroup: 5
				},
				768: {
					slidesPerView: 7,
					slidesPerGroup: 7
				},
				1024: {
					slidesPerView: 9,
					slidesPerGroup: 9
				},
			},
		});

		brandsSlider.querySelector(".swiper-wrapper").classList.remove("gap-2.5")
	}
}

function productGallerySwiperScroller () {
	const productGallerySwiper = document.querySelectorAll(".mobile-product-gallery-scroller");
	productGallerySwiper.forEach((scroller) => {
		const scrollerWrapper = scroller.querySelector("ul")
		scrollerWrapper.classList.add("swiper-wrapper");
		scrollerWrapper.querySelectorAll("li").forEach((item) => {
			item.classList.add("swiper-slide");
		})

		const swiperInstance = new Swiper(scroller, {
			slidesPerView: 1.2,
			spaceBetween: '16px',
			autoplay: false,
			loop: false,
			breakpoints: {
				320: {
					slidesPerView: 1.2,
				},
				640: {
					slidesPerView: 2.2,
				}
			}
		});
	})
}


let productListSwiperInstances = [];

function initProductListScroller () {
	const productListScroller = document.querySelectorAll(".mobile-grid-scroller");

	if (window.innerWidth <= 768) {
		// Only initialize if not already initialized
		if (productListSwiperInstances.length === 0) {
			productListScroller.forEach((scroller) => {
				const scrollerWrapper = scroller.querySelector("ul")
				scrollerWrapper.classList.add("swiper-wrapper");
				scrollerWrapper.querySelectorAll("li").forEach((item) => {
					item.classList.add("swiper-slide");
				})

				const swiperInstance = new Swiper(scroller, {
					modules: [Navigation, Autoplay],
					slidesPerView: 1.2,
					spaceBetween: '20px',
					autoplay: {
						delay: 2000,
					},
					loop: false,
					breakpoints: {
						320: {
							slidesPerView: 1.2,
						},
						640: {
							slidesPerView: 2.2,
						},
						768: {
							slidesPerView: 4,
						}
					},
					on: {
						init: function(swiper) {
							console.log('init');
						}
					}
				});

				productListSwiperInstances.push(swiperInstance);
			})
		}
	} else {
		// Destroy all instances on desktop
		if (productListSwiperInstances.length > 0) {
			productListSwiperInstances.forEach((instance) => {
				instance.destroy(true, true);
			});
			productListSwiperInstances = [];

			// Remove Swiper classes
			productListScroller.forEach((scroller) => {
				const scrollerWrapper = scroller.querySelector("ul")
				if (scrollerWrapper) {
					scrollerWrapper.classList.remove("swiper-wrapper");
					scrollerWrapper.querySelectorAll("li").forEach((item) => {
						item.classList.remove("swiper-slide");
					})
				}
			})
		}
	}
}

document.addEventListener("DOMContentLoaded", function () {
	// Initialize brand links slider
	initBrandsSlider();
	productGallerySwiperScroller();

	if(window.innerWidth <= 768){
		initProductListScroller();
	}
});

// Reinitialize brands slider on window resize
window.addEventListener('resize', function() {
	initBrandsSlider();

	if(window.innerWidth <= 768){
		initProductListScroller();
	} else {
		initProductListScroller()?.destroy(true, true);
	}
});

// INIT
Alpine.start();
